// 出库装船BL清单·coupang托盘表 엑셀 — 서버(/api/coupassCustoms/blSheet·palletSheet)가 준 headers·rows 를 샘플 열 순서·헤더 문구 그대로 쓴다.
// 수식 없음(값만). 칸 안 줄바꿈은 그대로 둔다.
import * as XLSX from 'xlsx'

export function writeSheetXlsx(headers, rows, sheetName, fileName) {
  const ws = XLSX.utils.aoa_to_sheet([headers].concat(rows))
  ws['!cols'] = headers.map((h, i) => ({ wch: Math.min(40, Math.max(10, ...[h].concat(rows.map(r => r[i])).map(v => String(v === undefined || v === null ? '' : v).split('\n').reduce((a, l) => Math.max(a, l.length), 0)))) }))
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)
  XLSX.writeFile(wb, fileName)
}

export const blSheetFileName = date => '出库装船BL清单_' + date + '.xlsx'
export const palletSheetFileName = date => 'coupang托盘表_' + date + '.xlsx'

// 화면에서 고친 칸은 문자열 — 엑셀에는 숫자처럼 생긴 것만 숫자로 내려보낸다(고치는 동안은 문자 그대로 둬야 «0.05» 를 칠 수 있다)
export const sheetRowsForXlsx = (rows, editable) => rows.map(r => r.map((v, i) => (editable.includes(i) && typeof v === 'string' && /^-?\d+(\.\d+)?$/.test(v.trim()) ? Number(v) : v)))

// CNY 금액 = 관세사 정산금액 합계 ÷ 汇率 (서버가 처음 채우는 식과 같다. 汇率 칸을 고치면 이 값을 다시 넣는다)
export function cnyFromRow(row, calc) {
  const total = row[calc.total]
  const rate = row[calc.rate]
  const t = Number(total)
  const r = Number(rate)
  return total === '' || rate === '' || !isFinite(t) || !isFinite(r) || r <= 0 ? '' : Math.round(t / r * 100) / 100
}
